import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';


class AgentRole extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;
        if(this.props.role==1){
            return (
                <span className="badge badge-danger" title="Has all the powers">Owner</span>
            );
        }
        else if(this.props.role==2){
            return (
                <span className="badge badge-warning" >Administrator</span>
            );
        }
        else if(this.props.role==3){
            return (
                <span className="badge badge-info" >Agent</span>
            );
        } else{
            <span>-</span>
        }
    }
}

export default withTranslation()(AgentRole);
